import { Button, Icon } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.less';

const cx = classNames.bind(styles);


const defaultProps = {
  collapsed: false,
  collapsible: false,
  position: 'left',
  children: null,
  style: {},
  onToggleClick: null,
};
const propTypes = {
  collapsed: PropTypes.bool,
  collapsible: PropTypes.bool,
  position: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.element
  ]),

  onToggleClick: PropTypes.func,
  style: PropTypes.object,
};

const Sider = ({
  collapsed,
  collapsible,
  position,
  children,
  style,
  onToggleClick,
}) => {
  const baseCls = cx('sider');
  const collapsedCls = collapsed ? cx('collapsed') : '';
  const posCls = `${position === 'left' || position === 'right' ? cx('vertical') : cx('horizontal')} ${cx(position)}`;

  return (
    <div
      className={`${baseCls} ${posCls} ${collapsedCls}`}
      style={style}
    >
      {collapsible ? (
        <Button onClick={onToggleClick} className={cx('collapseBtn')}>
          <Icon type="double-right" />
        </Button>
      ) : null}
      {children}
    </div>
  );
};

Sider.defaultProps = defaultProps;
Sider.propTypes = propTypes;
export default Sider;



// WEBPACK FOOTER //
// ./src/components/ui/Sider/index.jsx